import React from "react";
import { useEffect, useState, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import VideoContext from "../../store/video-context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { concat } from "lodash";
import OutsideClickHandler from "react-outside-click-handler";
import {
  Modal,
  Button,
  Container,
  Row,
  Col,
  Carousel,
  CarouselItem,
} from "react-bootstrap";
import {
  FaCaretDown,
  FaPlay,
  FaPause,
  FaSlash,
  FaEye,
  FaFastForward,
  FaFastBackward,
  FaRegPlayCircle,
} from "react-icons/fa";
import styles from "./NotificationArea.module.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectCoverflow, Autoplay,Navigation,Pagination } from 'swiper';
import { url } from "inspector";
 
/// if conf id is 0 dont run, if its not equal to zero run every 10 sec
/// use api to get rest of the videos
/// display video notif if status_id = 1
 
const NotificationArea = (props: any) => {
  const vContext = useContext(VideoContext);
  const [confData, setConfData] = useState([]);
  const [nextConfData, setNextConfData] = useState([]);
  const [data, setData] = useState("0");
  const [statusData, setStatusData] = useState("2");
  useEffect(() => {
    loadVideoData(vContext.transId, vContext.userId);
  }, []);
  useEffect(() => {
  
    
    console.log("******************");
   
    //alert("conf="+statusData+"-"+data);
  /*  if(data != "0" && statusData == "2")
    getNextConfTx();
    if(data != "0" && statusData != "2")
    {
      check_conf();
    setInterval(() => check_conf(), 15000);
    }*/
  }, [data,statusData]);
 


  const loadVideoData = (transId: any, userId: any) => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=getVideoData&transID=" +
        transId +
        "&userID=" +
        userId
    )
      .then((res) => res.json())
      .then((result) => {
        let data = result.data[0].txData[0].transmission_conference_id;
     //   console.log("yes11", data);
    // alert(data);
     //alert(result.data[0].txData[0].transmission_status);
     let conf_id = data;
     let tx_status = result.data[0].txData[0].transmission_status;
        setData(data);
        setStatusData(result.data[0].txData[0].transmission_status);

        //alert("conf="+tx_status+"-"+conf_id);
        if(conf_id != "0" && tx_status == "2")
        getNextConfTx();
        if(conf_id != "0" && tx_status != "2")
        {
          check_conf();
        setInterval(() => check_conf(), 15000);
        }
      });
  };
 
 
 
  const check_conf = () => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=getConfTx&transID=" +
        vContext.transId
    )
      .then((res) => res.json())
 
      .then((confdata: any) => {
        const all = confdata.data;
        //   console.log("yes", all);
        setConfData(all);
       // loadVideoData(vContext.transId, vContext.userId);

        var notif_div = document.getElementById("notif-div");     
        if(notif_div){
            //#myElementID element DOES exists
           //document.getElementById("conversation")!.style.height = document.getElementById("conversation")!.clientHeight - document.getElementById("notif-div")!.clientHeight+"px";
           var primaryAd = document.getElementById("primaryAd");  
           if(primaryAd){  
             document.getElementById("conversation")!.style.height = (window.innerHeight - 54-10 - document.getElementById("primaryAd")!.clientHeight -document.getElementById("notif-div")!.clientHeight- 45) + "px";
           } else {
             document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - 25-document.getElementById("notif-div")!.clientHeight) + "px";
           }
        }
        else{
          var primaryAd = document.getElementById("primaryAd");  
          if(primaryAd){  
            document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - document.getElementById("primaryAd")!.clientHeight - 45) + "px";
          } else {
            document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - 25) + "px";
          }
        }
      })
      .catch((error) => {
        console.error("Error:(getconferror)", error);
      });
  };

  const getNextConfTx = () => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=getNextConfTx&transID=" +
        vContext.transId
    )
      .then((res) => res.json())
 
      .then((confdata: any) => {
        const all = confdata.data;
        //   console.log("yes", all);
        setNextConfData(all);
       // loadVideoData(vContext.transId, vContext.userId);

        var notif_div = document.getElementById("notif-div");     
        if(notif_div){
            //#myElementID element DOES exists
           //document.getElementById("conversation")!.style.height = document.getElementById("conversation")!.clientHeight - document.getElementById("notif-div")!.clientHeight+"px";
           var primaryAd = document.getElementById("primaryAd");  
           if(primaryAd){  
             document.getElementById("conversation")!.style.height = (window.innerHeight - 54-10 - document.getElementById("primaryAd")!.clientHeight -document.getElementById("notif-div")!.clientHeight- 45) + "px";
           } else {
             document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - 25-document.getElementById("notif-div")!.clientHeight) + "px";
           }
        }
        else{
          var primaryAd = document.getElementById("primaryAd");  
          if(primaryAd){  
            document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - document.getElementById("primaryAd")!.clientHeight - 45) + "px";
          } else {
            document.getElementById("conversation")!.style.height = (window.innerHeight - 54 - 25) + "px";
          }
        }

        
      })
      .catch((error) => {
        console.error("Error:(getconferror)", error);
      });
  };
 
  const styleSheet = {
    backgroundColor: "transparent",
    display: "flex",
  
  };
 
  
  SwiperCore.use([Autoplay,Navigation,Pagination]);
 
 
 
  return (
    <>
      {data === "0" ? (
        <></>
      ) : ( <>
        
         <Swiper
              spaceBetween={1}
              slidesPerView={1}
              pagination={{
                clickable: true,
              }}
               autoplay={{
                "delay": 5000,
                "disableOnInteraction": false
              }}
           
            >
        
              {confData.map((obj: any) => {
                return (
                  obj.status_id == "1" && (
                    <SwiperSlide               
                    className= "img-fluid w-100 notif-section"
                    >
                      <div id="notif-div"  className= "blue-shadow-box center-ad"> 
                        <a href={"?trans_id=" + obj.trans_id} target="_blank">
                          <>
                           {/*} <div
                              id="img-div"
                              style={{
                                backgroundImage: obj.thumbnail_img,
                                backgroundSize: "100% 100%",
                                backgroundColor: "black",
                                borderRadius: "9px",
                                display: "flex", 
                                justifyContent:"center",
                                alignItems: "center"
                              }}
                            > 
                              <FaRegPlayCircle
                                  size={26}
                                  className="play-icon"
                                  style={{
                                  color: "white",
                              }}
                              />
                            */}
                             <div
                              id="img-div"
                              style={{
                                position: "relative"
                              }}
                            >
                             {/*} <FaRegPlayCircle
                                  size={26}
                                  className="play-icon"
                                  style={{
                                  color: "white",
                              }}
                              />
                            */}
                              
                              <img width="95%" height="95%" src={obj.thumbnail_img} alt="thumbnail" />
                              <div style={{
                                position: "absolute",
                                top: "29%",
                                left: "35%"
                              }}>
                            <img width="90%" height="90%" src={"https://www.lapguru.com/style/images/commonspeciality/react-next-play.png"} alt="Play" />
                            </div>

                            </div>
                            <div id="content-div">
                              <p id="notif-title">{obj.transmission_name}</p>
                              <p id="notif-org">
                                Organized by: {obj.organized_by}
                              </p>
                            <p></p>
                              <Button>Live Now</Button>
                            </div>
                          </>
                        </a>
                      </div>
                    </SwiperSlide>
                  )
                );
              })}

{nextConfData.map((obj: any) => {
                return (
                  obj.status_id == "2" && (
                    <SwiperSlide               
                    className= "img-fluid w-100 notif-section"
                    >
                      <div id="notif-div"  className= "blue-shadow-box center-ad"> 
                        <a href={"?trans_id=" + obj.trans_id+"#videoDiv"} target="_self">
                          <>
                            <div
                              id="img-div"
                              style={{
                                position: "relative"
                              }}
                            >
                             {/*} <FaRegPlayCircle
                                  size={26}
                                  className="play-icon"
                                  style={{
                                  color: "white",
                              }}
                              />
                            */}
                              
                              <img width="95%" height="95%" src={obj.thumbnail_img} alt="thumbnail" />
                              <div style={{
                                position: "absolute",
                                top: "29%",
                                left: "35%"
                              }}>
                            <img width="90%" height="90%" src={"https://www.lapguru.com/style/images/commonspeciality/react-next-play.png"} alt="Play" />
                            </div>
                            </div>
                            <div id="content-div">
                              <p id="notif-title">{obj.transmission_name}</p>
                              <p id="notif-org">
                                Organized by: {obj.organized_by}
                              </p>
                             <p></p>
                             <Button style={{backgroundColor:"blue",color:"white",borderColor: "blue",fontSize: "0.8em"}}><b>Watch Next Video</b></Button>
                            </div>
                          </>
                        </a>
                      </div>
                    </SwiperSlide>
                  )
                );
              })}
            </Swiper>
   
        </>
      )}
    </>
  );
};
 
export default NotificationArea;